import axios from 'axios';

const authAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

authAxios.interceptors.request.use( config => {
   const access_token = localStorage.getItem('access_token');
   if(access_token) {
      config.headers['Authorization'] = `Bearer ${access_token}`
   }
   return config
}, error => Promise.reject(error) )

authAxios.interceptors.response.use( (response) => {
 return response;
}, (error) => {
   if (error.response) {
      switch (error.response.status) {
         case 401:
            window.location ='/timeout'
            break;
         default:
            break;
      }
   }
   return Promise.reject(error)
})

export default authAxios